<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">

        <div style="page-break-inside: avoid">
            <h5>{{ title}}</h5>
            <table class="optionalComponentSectionTable">
                <tr style="font-weight: bold;">
                    <td>Type</td>
                    <td>SubType</td>
                    <td class="alignRight">Production</td>
                    <td class="alignRight">Reserves</td>
                    <td class="alignRight">Max Water Depth (m)</td>
                    <td class="alignRight">Discovery Date</td>
                    <td class="alignRight">Life</td>
                </tr>
                <tr *ngFor="let fieldHydrocarbon of fieldHydrocarbons">
                    <td style="padding: 5px;" [innerHTML]="fieldHydrocarbon.type | highlight: searchTerm"></td>
                    <td>{{fieldHydrocarbon.subType}}</td>
                    <td class="alignRight"><span [hidden]="!fieldHydrocarbon.production">{{fieldHydrocarbon.production | number}}
                            {{fieldHydrocarbon.productionUnit}}</span></td>
                    <td class="alignRight"><span [hidden]="!fieldHydrocarbon.reserves">{{fieldHydrocarbon.reserves | number}}
                            {{fieldHydrocarbon.reservesUnit}}</span></td>
                    <td class="alignRight"><span [hidden]="!fieldHydrocarbon.maxWaterDepthMetres">{{fieldHydrocarbon.maxWaterDepthMetres | number}}</span></td>
                    <td class="alignRight"><span [hidden]="!fieldHydrocarbon.discoveryDate">{{fieldHydrocarbon.discoveryDate| date: 'dd MMMM yyyy'}}</span></td>
                    <td class="alignRight"><span [hidden]="!fieldHydrocarbon.life">{{fieldHydrocarbon.life}} years</span></td>
                </tr>
            </table>
        </div>
    <!-- </div> -->
</ng-template>

<ng-template #template_mobile let-title="title">
    <!-- <div *ngIf="data$ | async as fieldHydrocarbons"> -->
        <div style="page-break-inside: avoid">
            <h5>{{title}}</h5>
            <div class="optionalComponentSectionTable" *ngFor="let fieldHydrocarbon of fieldHydrocarbons">
                <div>
                    <span style="font-weight:bold">Type</span>
                    <span *ngIf="fieldHydrocarbon.subType"> / SubType: </span>
                    <span [innerHTML]="fieldHydrocarbon.type | highlight: searchTerm"></span>
                    <span *ngIf="fieldHydrocarbon.subType"> / {{ fieldHydrocarbon.subType }}</span>
                </div>
                <div *ngIf="fieldHydrocarbon.production">
                    <span style="font-weight:bold">Production: </span>
                    <span>{{ fieldHydrocarbon.production | number }} {{ fieldHydrocarbon.productionUnit }}</span>
                </div>
                <div *ngIf="fieldHydrocarbon.reserves">
                    <span style="font-weight:bold">Reserves: </span>
                    <span>{{ fieldHydrocarbon.reserves | number }} {{ fieldHydrocarbon.reservesUnit }}</span>
                </div>
                <div *ngIf="fieldHydrocarbon.life">
                    <span style="font-weight:bold">Life: </span>
                    <span>{{ fieldHydrocarbon.life }} years</span>
                </div>
            </div>
        </div>
    <!-- </div> -->
</ng-template>